var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenXyoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8425 3.97453C23.8425 1.86516 22.291 0.168281 20.3738 0.168281C17.7769 0.0468748 15.1285 0 12.4219 0H11.5782C8.87817 0 6.22504 0.0468749 3.62817 0.16875C1.71567 0.16875 0.164103 1.875 0.164103 3.98438C0.0469159 5.65266 -0.00277159 7.32141 4.091e-05 8.99016C-0.00464659 10.6589 0.0484784 12.3292 0.159416 14.0011C0.159416 16.1105 1.71098 17.8214 3.62348 17.8214C6.3516 17.948 9.15004 18.0042 11.9954 17.9995C14.8454 18.0089 17.636 17.9495 20.3672 17.8214C22.2844 17.8214 23.836 16.1105 23.836 14.0011C23.9485 12.3277 24 10.6589 23.9954 8.98547C24.006 7.31672 23.955 5.64641 23.8425 3.97453ZM9.70317 13.5886V4.37766L16.5 8.98078L9.70317 13.5886Z",
    fill: "#FAF2EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenXyoutube);
export default __webpack_public_path__ + "static/media/OpenXyoutube.02ad5228ecd666392b1b7e2976882a02.svg";
export { ForwardRef as ReactComponent };